import React from "react"

import tokkenr_logo_transp from "../resources/images/tokkenr_logo_transp.png"


export default function TokkenR_logo({
    logoWidth,
    ...props
}) {
    return (
        <img src={tokkenr_logo_transp}
            width={logoWidth}
            style={{
                paddingRight: "15px",
                marginTop: '-5px',
                ...props
            }} />
    )
}
